/**
 * 客户信息
 */
import React from 'react';

import { Row, Col, Icon, Tooltip, DatePicker, Button, Input } from 'antd';

import PageLayout from '../../ui/PageLayout';

//客户信息
import ClientInfoEdit from './ClientInfoEdit';
//客户拜访记录
import ClientInteractionEdit from './ClientInteractionEdit';
import messager from '../../ui/messager';
import http from '../../../axios/http';
import moment from 'moment';
import DictSelect from '../../ui/DictSelect';
import { global_data } from '../../ui/auth';

class ClientInfoIndex extends React.Component {

    columns = [{
        title: '意向客户公司',
        dataIndex: 'name',
        width: '20%',
    }
    ,{
        title: '店名',
        dataIndex: 'shopName',
        width: '16%',
    }
    ,{
        title: '意向楼层',
        dataIndex: 'floor',
        width: '10%'
    }
    ,{
        title: '意向面积',
        dataIndex: 'area',
        width: '10%'
    }
    ,{
        title: '客户来源',
        dataIndex: 'customerSource',
        width: '10%'
    }
    ,{
        title: '目前状态',
        dataIndex: 'status',
        width: '10%'
    }
    ,{
        title: '细分业态',
        dataIndex: 'typeDetail',
        width: '10%'
    }
    , {
        title: '创建人',
        dataIndex: 'creator',
        width: '10%'
    }
    , {
        title: '创建时间',
        dataIndex: 'createDate',
        width: '10%'
    }
    , {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("CLIENT_MANAGE_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record.id)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("CLIENT_MANAGE_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record.id)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("CLIENT_MANAGE_ADD_RECORD")?
                <Tooltip title="增加跟进情况">
                    <Icon type="plus" className="table-operate-icon" onClick={this.addInteraction.bind(this, record)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        createVisible: false,
        buildingList: [],
        interactionVisible: false
    };

    componentDidMount() {
        http.get({
            url: "/berth/findBuilding",
            success: (res) => {
                let buildingList = res == null ? [] : res;
                this.setState({ buildingList: buildingList });

            }
        });
    }

    add = () => {
        this.state.initTypeDict();
        this.setState({ visible: true, editData: { "startTime": new moment() } });
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {}, interactionVisible: false});
    };

    update = (id, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/market/client/' + id,
            success: (res) => {
                this.state.initTypeDict(res.type);
                this.setState({ editData: res, visible: true, loadingVisible: false });
            },
            error: () => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    addInteraction = (record) => {
        this.setState({editData: record, interactionVisible: true})
    }

    delete = (id, e) => {
        messager.confirm("是否删除该客户信息？", () => {
            http.post({
                url: '/market/client/delete',
                data: { id: id },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (filed, value) => {
        let queryData = this.state.queryData;
        queryData[filed] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="公司名称"
                                    onSearch={this.inputSearch}
                                    style={{ width: 250, marginRight: '10px' }}
                                    enterButton
                                />
                                {/* <OrgSelect orgType={4} onChange={this.orgSelect.bind(this, "orgCode")} allowClear={true} style={{ width: 180, marginRight: '10px' }}/> */}
                                {/* <Select onChange={this.selectChange.bind(this, "buildingId")} placeholder="选择所属市场" style={{ width: 200, marginRight: '10px' }}>
                                    {this.state.buildingList.map(d =>
                                        <Select.Option key={d["id"]}>{d["buildingName"]}</Select.Option>
                                    )}
                                </Select> */}
                                 <DictSelect category="market_client_project" style={{ width: 180, marginRight: '10px' }} placeholder="合作项目"
                                    allowClear={true} onChange={this.selectChange.bind(this,"project")}/>
                                <DatePicker.RangePicker
                                    // defaultValue={[moment(), moment()]}
                                    allowClear={true}
                                    onChange={this.rangePickerChange} />
                            </Col>
                            <Col span={4}>
                                {global_data.authCode.includes("CLIENT_MANAGE_ADD")?
                                <Button type="primary" onClick={this.add} style={{ float: "right" }}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/market/client/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <ClientInfoEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    initTypeDict={(func) => {this.setState({initTypeDict: func})}}
                />
                <ClientInteractionEdit
                    visible={this.state.interactionVisible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                />
            </div>
        )
    }
}

export default ClientInfoIndex;